import type { HeroContent } from "./types";

import { AI_ASSISTANT, IS_CLINIC_APP } from "@/config/constants";

// Hero copy, kept out of the layout so wording is a one-file edit. The agent's
// name comes from AI_ASSISTANT so this can't drift from the product. No subline
// by design - the card already demonstrates the headline's claim, and it
// mirrors a real appointment row rather than inventing a surface.
const BOOKED_BY_AGENT = `${AI_ASSISTANT.label} booked this from WhatsApp · 4s`;

const CLINIC_HERO: HeroContent = {
  headline: "The front desk for modern clinics.",
  features: [
    { icon: "solar:bolt-linear", label: "Replies in seconds" },
    { icon: "solar:clock-circle-linear", label: "24/7 Coverage" },
    { icon: "solar:chat-round-line-linear", label: "Every Channel" },
    { icon: "solar:plug-circle-linear", label: "EHR Integration" },
  ],
  showcase: {
    name: "Andy Smith",
    initials: "AS",
    subject: "Dental Cleaning",
    assignee: "Dr. Yousef",
    when: "Tomorrow · 10:30 AM",
    status: "Confirmed",
    source: BOOKED_BY_AGENT,
  },
};

const GENERAL_HERO: HeroContent = {
  headline: "The front desk for modern business.",
  features: [
    { icon: "solar:bolt-linear", label: "Replies in seconds" },
    { icon: "solar:clock-circle-linear", label: "24/7 Coverage" },
    { icon: "solar:chat-round-line-linear", label: "Every Channel" },
    { icon: "solar:plug-circle-linear", label: "CRM Integration" },
  ],
  showcase: {
    name: "Andy Smith",
    initials: "AS",
    subject: "Product Demo",
    assignee: "Sales",
    when: "Tomorrow · 10:30 AM",
    status: "Confirmed",
    source: BOOKED_BY_AGENT,
  },
};

export const HERO = IS_CLINIC_APP ? CLINIC_HERO : GENERAL_HERO;

// Onboarding reuses the hero but not its headline: by then the visitor has
// signed up and is mid-form, so the pitch is replaced by the payoff for
// finishing it - which is exactly what the showcase card above already shows.
export const ONBOARDING_HERO_HEADLINE = IS_CLINIC_APP
  ? "Every booking like this one, handled for you."
  : "Every order like this one, handled for you.";
